import { __makeTemplateObject, __assign, __rest } from 'tslib';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { typography } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';

var StyledText = /*#__PURE__*/styled("p").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "Text__StyledText",
  componentId: "sc-1su33tx-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 0;\n  margin-bottom: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  ", ";\n"], ["\n  margin-top: 0;\n  margin-bottom: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  ", ";\n"])), typography);
var defaultStyles = {
  letterSpacing: "tight",
  lineHeight: "normal",
  color: "text.normal",
  fontFamily: "normal"
};
var textVariants = {
  lg: __assign(__assign({}, defaultStyles), {
    fontSize: [4, 5, 7],
    fontFamily: "heading"
  }),
  md: __assign(__assign({}, defaultStyles), {
    fontSize: [2, 4]
  }),
  sm: __assign(__assign({}, defaultStyles), {
    fontSize: [1, 2]
  }),
  sub: __assign(__assign({}, defaultStyles), {
    fontWeight: 500,
    textTransform: "uppercase",
    color: "dorianGray",
    lineHeight: "none",
    fontSize: ["10px"]
  })
};
var Text = forwardRef(function (_a, ref) {
  var variant = _a.variant,
    rest = __rest(_a, ["variant"]);
  var styles = textVariants[variant];
  return React__default.createElement(StyledText, __assign({
    ref: ref
  }, styles, rest));
});
Text.defaultProps = {
  variant: "md"
};
Text.displayName = "Text";
var templateObject_1;

export { StyledText, Text, textVariants };
//# sourceMappingURL=Text.js.map
